// @flow

import React from 'react';
import type { Element } from 'react';

import './css/LeftRight.css';


type T_LeftRightProps = {
  left : Element<*>,
  right: Element<*>,
  cls? : string
};



export default function LeftRight(props: T_LeftRightProps) {
  const cls = props.cls ? ` ${props.cls}` : '';
  
  return (
    <div className={`LeftRight ${cls}`} style={{width: '100%', fontSize: 'small', marginTop: 0}}>
      <div className='Left'>
        {props.left}
      </div>
      
      <div className='Right'>
        {props.right}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/LeftRight.jsx